import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import Session from '@bringg/dashboard-sdk/dist/Services/Identity/Session';
import { Authentication, DashboardSdk } from '@bringg/frontend-utils';
import { StorageType } from '@bringg/frontend-utils/dist/services/credentials-storage';
import axios from 'axios';

import { getDashboardSdk } from '../helpers';

export const AuthContext = createContext({} as any);

export function AuthProvider({ children }: any) {
  const [auth, setAuthentication] = useState<Authentication | null>(null);
  const [dashboardSdk, setSdk] = useState<DashboardSdk | null>(null);
  const [session, setSession] = useState<Session | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const isLoggedIn = useMemo(() => Boolean(session), [session]);

  useEffect(() => {
    async function fetchAuth() {
      const _dashboardSdk = await getDashboardSdk();
      const authentication = new Authentication(StorageType.LocalStorage, _dashboardSdk);

      try {
        await _dashboardSdk.init();
      } catch (ex) {
        console.error(ex);
      }

      setAuthentication(authentication);
      setSdk(_dashboardSdk);
      if (_dashboardSdk.sdk?.session) {
        setSession(_dashboardSdk.sdk.session);
      }
      setIsLoading(false);
    }

    fetchAuth();
  }, []);

  useEffect(() => {
    if (!session) {
      return;
    }

    axios.defaults.headers.common.Authorization = `Token token=${session.user.authentication_token}`;
  }, [session]);

  const onLoggedIn = useCallback(() => {
    setSession((dashboardSdk as DashboardSdk).sdk.session);
  }, [dashboardSdk]);

  return (
    <AuthContext.Provider
      value={{
        onLoggedIn,
        isLoggedIn,
        isLoading,
        dashboardSdk,
        logout: () => {
          (auth as Authentication).clearCredentials();
          setSession(null);
        },
        login: (email: string, password: string, ...rest: any) =>
          (auth as Authentication).attemptToLogin(email, password, ...rest),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
